module.exports = __webpack_public_path__ + "img/thumbs-down-solid.svg";